/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppListEditsVideoEditorEditsQueryResponse, WebAppListEditsVideoEditorEditsQueryParams } from "../models/WebAppListEditsVideoEditorEdits";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppListEditsVideoEditorEdits } from "../axios/webAppListEditsVideoEditorEdits";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppListEditsVideoEditorEditsQueryKey = (params: WebAppListEditsVideoEditorEditsQueryParams) => ["api-v2", { url: '/web-app/video-editor/edits' }, ...(params ? [params] : [])] as const

export type WebAppListEditsVideoEditorEditsQueryKey = ReturnType<typeof webAppListEditsVideoEditorEditsQueryKey>

export function webAppListEditsVideoEditorEditsQueryOptions(params: WebAppListEditsVideoEditorEditsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppListEditsVideoEditorEditsQueryKey(params)
        return queryOptions<WebAppListEditsVideoEditorEditsQueryResponse, ResponseErrorConfig<Error>, WebAppListEditsVideoEditorEditsQueryResponse, typeof queryKey>({
         enabled: !!(params),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppListEditsVideoEditorEdits(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List edits for the client scoped to a fragment; each item includes creator, published platforms, and rendered video URL when a completed render exists
 * {@link /web-app/video-editor/edits}
 */
export function useWebAppListEditsVideoEditorEdits<TData = WebAppListEditsVideoEditorEditsQueryResponse, TQueryData = WebAppListEditsVideoEditorEditsQueryResponse, TQueryKey extends QueryKey = WebAppListEditsVideoEditorEditsQueryKey>(params: WebAppListEditsVideoEditorEditsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<WebAppListEditsVideoEditorEditsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppListEditsVideoEditorEditsQueryKey(params)
         

         const query = useQuery({
          ...webAppListEditsVideoEditorEditsQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}